import { createFileRoute } from '@tanstack/react-router'
import { FeatureGate } from '@/components/feature-locked'

export const Route = createFileRoute(
  '/_authenticated/org/$orgId/workspace/$workspaceId/video'
)({
  component: VideoLayout,
})

function VideoLayout() {
  return <FeatureGate feature='video' />
}
